import { useState } from 'react';
import Header from '@/components/feature/Header';
import HeroSlider from '@/components/feature/HeroSlider';
import ServicesSection from '@/components/feature/ServicesSection';
import AboutSection from '@/components/feature/AboutSection';
import ServiceAreas from '@/components/feature/ServiceAreas';
import Gallery from '@/components/feature/Gallery';
import FacebookFeed from '@/components/feature/FacebookFeed';
import Reviews from '@/components/feature/Reviews';
import ContactSection from '@/components/feature/ContactSection';
import Footer from '@/components/feature/Footer';
import QuoteModal from '@/components/feature/QuoteModal';
import AiBookingWidget from '@/components/feature/AiBookingWidget';

export default function Home() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white font-body">
      <Header />
      <main>
        <section id="home">
          <HeroSlider onOpenQuote={() => setQuoteOpen(true)} />
        </section>
        <ServicesSection />
        <AboutSection />
        <ServiceAreas />
        <Gallery />
        <FacebookFeed />
        <Reviews />
        <ContactSection onOpenQuote={() => setQuoteOpen(true)} />
      </main>
      <Footer />
      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
      <AiBookingWidget />
    </div>
  );
}